import { TableCell, TableRow } from '@material-ui/core';
import { Checkbox } from 'material-ui';
import * as React from 'react';
import { ReviewModel } from '../../../../models'
import { Views } from '../../../abstract';

const ReviewTableViewHeader = [
    { label: 'Наименование' },
    { label: 'Дата создания' }
]

interface IReviewTableViewProps {
    onSearchReview: (s: string) => void
    onNewReview: () => void
    onEdit: (uspId: string) => void
}

interface IReviewTableViewState {
    selectedRows: object[]
    page: number
}

class ReviewTableView<P, S> extends Views.TableView<P & IReviewTableViewProps, S & IReviewTableViewState> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            selectedRows: [],
            model: this.props.model,
            isDeleteConfirmationDialogOpened: false,
            page: 0
        }
        this.state = defaultState
    }

    public rowAtIndex(usp: ReviewModel, index: number): JSX.Element {
        const { selectedRows } = this.state;
        const { model } = this.props;
        return (
            <TableRow selected={selectedRows.filter(r => selectedRows.length && r['selected'] === true).length === (model as ReviewModel[]).length || selectedRows.filter(r => r['index'] === index && r['selected'] === true).length ? true : false} key={index.toString()}>
                <TableCell className="checkbox-cell" style={{ width: 30 }}>
                    <Checkbox
                        checked={selectedRows.filter(r => selectedRows.length && r['selected'] === true).length === (model as ReviewModel[]).length || selectedRows.filter(r => r['index'] === index && r['selected'] === true).length ? true : false}
                        onCheck={() => this.onSelectRow(index)}
                    />
                </TableCell>
                <TableCell style={{ minWidth: 50 }}>{usp.name}</TableCell>
                <TableCell style={{ minWidth: 50 }}>{usp.createdAt.toLocaleDateString()}</TableCell>
            </TableRow>
        )
    }

    public render_topBar(): JSX.Element {
        const { selectedRows } = this.state;
        const { onNewReview, onSearchReview, onEdit, model } = this.props;
        return (
            <Views.StandartTableViewTopBar 
                onSearch={(sText: string) => onSearchReview(sText)}
                onEdit={() => onEdit((model as ReviewModel[])[selectedRows.filter(r => r['selected'] === true)[0]['index']].id)} 
                editDisabled={selectedRows.filter(r => r['selected'] === true).length !== 1 ? true : false}
                onAdd={() => onNewReview()}
                onDelete={() => this.onDelete()} 
                deleteDisabled={selectedRows.filter(r => r['selected'] === true).length === 0 ? true : false}
            />
        )
    }

    public tableViewHeader() {
        return ReviewTableViewHeader;
    }

    public labelRowsPerPage() {
        return 'Отзывов на странице:';
    }
}

export default ReviewTableView;



// WEBPACK FOOTER //
// ./src/app/dashboard/reviews/main/ReviewTableView.tsx